import React from 'react';
import './ThinkingText.css';

/**
 * ThinkingText - A reusable component that displays text with an animated gradient effect
 * 
 * @param {string} text - The text to display (default: "Thinking through your request…")
 * @param {string} speed - Animation speed: 'slow', 'normal', or 'fast' (default: 'normal')
 * @param {string} className - Additional CSS classes to apply
 */
const ThinkingText = ({ 
  text = "Thinking through your request…", 
  speed = 'normal',
  className = '' 
}) => {
  const speedMap = {
    slow: '4s',
    normal: '2.5s',
    fast: '1.5s'
  };

  const animationDuration = speedMap[speed] || speedMap.normal;

  return (
    <span 
      className={`thinking-text ${className}`}
      style={{ '--animation-duration': animationDuration }}
    >
      {text}
    </span>
  );
};

export default ThinkingText;

